import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useParams } from "react-router-dom";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useBusinessQuery from "../../store/Bussiness/useBusinessQuery";
import useStyles from "../../SharedClass/sharedClass";
import { variableContext } from "../../context/VariableContex";
import ProductCard from "../../components/ProductCard";
import BookmarkNotFound from "../myListing/bookmark/bookmarkNotFound/BookmarkNotFound";
import { MdDashboard } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import CategoreyCard from "../../components/CategoreyCard";
import useCommonQuery from "../../store/common/useCommonQuery";
import noPic from "../../assets/no-pic.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import category2 from "../../assets/category2.svg";
import "./PublicServiceCenter.css";

function PublicServiceCenter() {
  const { locationData } = useContext(variableContext);

  const history = useHistory();
  const { id } = useParams();
  const inputRef = useRef();

  const classes = useStyles();

  const [value, setValue] = useState("");
  const [search, setSearch] = useState("");
  const [toggle, setToggle] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [allSubcategories, setAllSubcategories] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const { data: categoryList, isLoading: categoryLoading } = useCommonQuery.Get_subcategory({
    id,
    search,
    limit: 50,
    offset: currentPage * 50,
  });

  // Call public service API when no ID is provided
  const { 
    data: publicServiceData, 
    isLoading: publicServiceLoading,
    isError: publicServiceError,
    error: publicServiceErrorData
  } = useCommonQuery.Get_public_serivce({
    limit: 20,
    offset: 0,
  });

  console.log('🏛️ Public Service API Data:', publicServiceData);
  console.log('🔍 Route ID:', id);
  console.log('⚠️ Public Service API Error:', publicServiceError);
  console.log('📝 Public Service Error Details:', publicServiceErrorData);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (e.target.value == "location") {
      history.push("/location-search");
    }
  };

  useEffect(() => {
    if (categoryList && categoryList.data) {
      if (currentPage === 0) {
        // First page - replace all subcategories
        setAllSubcategories(categoryList.data.results || []);
      } else {
        // Additional pages - append subcategories
        setAllSubcategories(prev => [...prev, ...(categoryList.data.results || [])]);
      }
      
      // Check if there are more subcategories to load
      if (categoryList.data.results && categoryList.data.results.length < 50) {
        setHasMore(false);
      }
      
      setLoadingMore(false);
    }
  }, [categoryList, currentPage]);

  // Handle scroll to load more
  const handleScroll = useCallback(() => {
    if (loadingMore || !hasMore || categoryLoading) return;
    
    const scrollElement = document.getElementById("parent-div");
    if (scrollElement) {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;
      
      // Load more when user is near bottom (100px from bottom)
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        setLoadingMore(true);
        setCurrentPage(prev => prev + 1);
      }
    }
  }, [loadingMore, hasMore, categoryLoading]);

  useEffect(() => {
    const scrollElement = document.getElementById("parent-div");
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => scrollElement.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  const handleGridView = () => {
    setToggle(false);
  };
  const handleListView = () => {
    setToggle(true);
  };

  const handleClick = (name) => {
    history.push(`/category/${id}/subCategory/${name}`);
  };

  return (
    <div
      id="parent-div"
      ref={inputRef}
      style={{ height: "100vh", overflowY: "scroll" }}
    >
      <div
        className="psc-header"
        style={{
          backgroundColor: "#fff",
          boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
          color: "black",
          padding: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "15px",
          }}
        >
          <ArrowBackIcon
            onClick={() => history.push("/")}
            style={{
              color: "black",
            }}
          />
          <Typography style={{ fontSize: "16px", fontWeight: "600" }}>
            Public Service Center
          </Typography>
        </Box>

        <div className="dropdown-search-body">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box className={classes.categoryLocSearch}>
                <img src="/images/loc.png" alt="" />
                <FormControl sx={{ flex: 1 }}>
                  <Select
                    value={value}
                    onChange={handleChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important",
                      },
                      "& .MuiSelect-select": {
                        color: "rgba(33, 130, 177, 1) !important",
                        fontSize: "16px !important",
                        fontWeight: "600 !important",
                      },
                    }}
                  >
                    <MenuItem value="">{locationData?.locationName}</MenuItem>
                    <MenuItem value="location">select location</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className={classes.categoryLocSearch}>
                <img src={category2} alt="" />

                <Button
                  sx={{
                    flex: 1,
                    textTransform: "none",
                    paddingLeft: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                  endIcon={<ArrowDropDownIcon />}
                  onClick={() => history.push("/subcategory-search")}
                >
                  Category
                </Button>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>

      <div>
        <div style={{ display: `${toggle ? "none" : "block"}` }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              marginTop: "10px",
            }}
          >
            <h4>All Categories</h4>
            <MdDashboard
              onClick={handleListView}
              style={{ fontSize: "33px" }}
            />
          </div>
          <Grid container spacing={2} style={{ padding: "1rem" }}>
            {allSubcategories &&
              allSubcategories?.map((items, idx) => {
                return (
                  <CategoreyCard
                    id={items.id}
                    title={items.name}
                    handleClick={handleClick}
                    image={items.image}
                    key={idx}
                  />
                );
              })}
          </Grid>
          
          {/* Loading indicator for scroll-to-load */}
          {loadingMore && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              padding: '20px',
              width: '100%'
            }}>
              <div style={{ 
                width: '30px', 
                height: '30px', 
                border: '3px solid #f3f3f3',
                borderTop: '3px solid #008ABB',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
            </div>
          )}
          
          {/* No more items indicator */}
          {!hasMore && allSubcategories.length > 0 && (
            <div style={{ 
              textAlign: 'center', 
              padding: '20px', 
              color: '#666',
              fontSize: '14px'
            }}>
              No more categories to load
            </div>
          )}
        </div>

        <div
          style={{ display: `${toggle ? "block" : "none"}`, marginTop: "10px" }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              <h4 style={{ margin: 0 }}>All Categories</h4>
              <GiHamburgerMenu
                onClick={handleGridView}
                style={{ fontSize: "33px" }}
              />
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <input
              placeholder="Search in Category"
              className="cat-inp"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <img
              style={{ position: "absolute", right: "2.4rem", top: "1.5rem" }}
              src="/images/insideSearch.png"
              alt=""
            />
          </div>
          <div className="list-Card-body">
            {allSubcategories &&
              allSubcategories?.map((item, i) => {
                return (
                  <div
                    className="list-Card"
                    onClick={() =>
                      history.push(`/category/${id}/subCategory/${item.id}`)
                    }
                    key={i}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <img
                        style={{ width: "25px" }}
                        src={item.image ? item.image : noPic}
                        alt="not found"
                      />
                    </div>
                    <Typography
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flex: 1,
                        fontSize: "12px",
                        fontWeight: "500",
                      }}
                    >
                      {item.name}
                    </Typography>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(PublicServiceCenter);
